.cr{flex-wrap:wrap;}